<div class="tree-item leaf">
	<div class="tree-item-value">
		<table class="leaf">
			<tr class="nodeHeader">
				<td class="nodeName">
					<span>{{ user.displayName }}</span>
				</td>
				<td class="nodeAction">
					<mat-icon id="menuIcon" class="menu-icon" (click)="displayContextualMenu($event, user); $event.preventDefault()">more_vert</mat-icon>
				</td>
			</tr>
			<tr class="node">
				<td class="nodeInfo" colspan="15">
					@if (isIdVisible === true) {
						<span>id&nbsp;:&nbsp;{{ user.id }}</span>
					}
					<span>account&nbsp;:&nbsp;{{ user.account }}</span>
					@if (!!cultureLabel) {
						<span>culture&nbsp;:&nbsp;{{ cultureLabel }}</span>
					}
					@if (!!roleName) {
						<span>role&nbsp;:&nbsp;{{ roleName }}</span>
					}
				</td>
			</tr>
		</table>
	</div>
</div>

<app-contextual-menu [items]="menuItems" direction="RIGHT" (menuChanged)="onMenuChanged($event)"></app-contextual-menu>
